import React from "react";
import "./Loading.css";

const LoadingPage: React.FC = () => {
  console.log("loading");
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingPage;
